import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js'

const DEFAULT_REGION: CountryCode = 'GB'

export function toE164(input: string | null | undefined, defaultRegion: CountryCode = DEFAULT_REGION): string | null {
  if (!input) return null
  const parsed = parsePhoneNumberFromString(input, defaultRegion)
  if (!parsed || !parsed.isValid()) return null
  return parsed.format('E.164')
}
